<script setup lang="ts">

import type { ICarbucksProfile } from "@domain/Carbucks";
import { BankDetails } from "../Components";
import { AddBankAccountPromotionTile } from "../Promotion";

const model = defineModel<ICarbucksProfile>( { required: true } );

</script>

<template>

    <div v-if="model.hasBankAccountDetails">
        <BankDetails v-model="model.bankAccount" />
    </div>

    <AddBankAccountPromotionTile v-else v-model="model" />

</template>